import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { CategoryProvider } from './context/CategoryContext'; // import provider
import { TopSellingProvider } from "./context/TopSellingContext";
import { AuthProvider } from "./context/AuthContext";
import { ProductProvider } from "./context/ProductContext";
import { CartProvider } from "./context/CartContext";
import { WishlistProvider } from "./context/WishlistContext";
import { ForgetPasswordProvider } from "./context/ForgetPasswordContext";
import { ProfileProvider } from "./context/ProfileContext";
import { AddressProvider } from "./context/AddressContext";
import { OrdersProvider } from "./context/OrdersContext";
import { RatingProvider } from "./context/RatingContext";
import { SubscriptionProvider } from "./context/SubscriptionContext";
import { SubscriptionProviderHome } from './context/SubscriptionContextHome';

import "./utils/recentlyViewed";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <BrowserRouter basename="/">
    <CategoryProvider>
      <TopSellingProvider>
          <AuthProvider>
            <ProductProvider>
              <CartProvider>
                <WishlistProvider>
                  <ForgetPasswordProvider>
                    <ProfileProvider>
                      <AddressProvider>
                        <OrdersProvider>
                          <RatingProvider>
                            <SubscriptionProvider>
                              <SubscriptionProviderHome>
                              <App />
                              </SubscriptionProviderHome>
                            </SubscriptionProvider>
                          </RatingProvider>
                        </OrdersProvider>
                      </AddressProvider>
                    </ProfileProvider>
                  </ForgetPasswordProvider>
                </WishlistProvider>
              </CartProvider>
            </ProductProvider>
          </AuthProvider>
      </TopSellingProvider>
    </CategoryProvider>
  </BrowserRouter>
);
